import { TranslationModel } from "models/translation";

export const enTranslations: TranslationModel = {
  yes: "Yes",
  no: "No",

  nav_logout: "Logout",
  not_found_title: "Not found",

  shared_login: "Login",

  privacy_policy: "Privacy policy",
  accessibility: "Accessibility statement",

  locale_fi: "Suomi",
  locale_en: "Englanti",
  locale_sv: "Ruotsi",

  show_in_locale_fi: "In Finnish",
  show_in_locale_en: "In English",
  show_in_locale_sv: "In Swedish",

  no_rows: "No data",
  go_back: "Go back",

  user_status: "Status",

  login_title: "Login",
  login_error: "Login failed",
  login_or: "Or",
  login_with_ftn: "Login with bank credentials",
  login_button: "Login",
  login_label_email: "Email address",
  login_label_password: "Password",
  login_link_expired_title: "Link invalid or expired",
  login_link_expired_text:
    "The link you opened is invalid or it has expired. Contact list admin to get a new link.",
  login_link_p1: "To update your information you need to log in.",
  login_link_p2:
    "You can begin by clicking the button below and authenticate using bank id.",
  login_begin_auth: "Begin authentication",

  field_datatype_text: "Avoin kenttä",
  field_datatype_textarea: "Avoin kappale",
  field_datatype_email: "Sähköpostiosoite",
  field_datatype_date: "Päivämäärä",
  field_datatype_datetime: "Päivämäärä- ja kellonaika",
  field_datatype_dropdown: "Pudotusvalikko",
  field_datatype_check: "Valintaruutu",
  field_datatype_ssn: "Henkilötunnus",
  field_datatype_phone: "Puhelinnumero",
  field_datatype_radio: "Monivalinta",

  user_status_draft: "Draft",
  user_status_invited: "Invited",
  user_status_progress: "In progress",
  user_status_submitted: "Submitted",
  user_status_approved: "Approved",

  email_filter_all: "All",
  email_filter_draft: "Draft",

  email_template_type_invitation: "Invitation",
  email_template_type_reminder: "Reminder",
  email_template_type_update_request: "Request to update",
  email_template_type_approved: "Approved",
  email_template_type_rejected: "Rejected",
  email_template_type_custom: "",

  column_type_field: "Field",
  column_type_name: "Name",
  column_type_modified: "Modified",
  column_type_status: "Status",
  column_type_liabilities: "Luottamus- ja virkatehtävä",

  column_width_automatic: "Automatic",

  pdf_status: "Status",
  pdf_date: "Date",
  pdf_contains_secret_material: "Includes information classefied as secret.",

  validate_required: "The field is required.",
  validate_email: "Invalid email address.",
  validate_phone: "Invalid phone number.",
  validate_ssn: "Invalid social security number.",
  validate_password_min8:
    "The password needs to be at least 8 characters long.",
  validate_localestring_translation_missing: "Missing translation",
  validate_password_same_as_old:
    "The password cannot be the same as the old password.",
  validate_password_do_not_match: "The passwords do not match.",

  email_event_type_bounce: "Invalid address",
  email_event_type_click: "Message clicked",
  email_event_type_delivery: "Message sent",
  email_event_type_open: "Message opened",
  email_event_type_reject: "Message rejected",
  email_event_type_complaint: "Marked as spam",
};
